import { render, staticRenderFns } from "./ProductSelecter.vue?vue&type=template&id=ef2b1966&scoped=true&"
import script from "./ProductSelecter.vue?vue&type=script&lang=js&"
export * from "./ProductSelecter.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelecter.vue?vue&type=style&index=0&id=ef2b1966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2b1966",
  null
  
)

export default component.exports